"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeRoute = exports.getPathParams = exports.resolveRewrite = exports.matchRoute = void 0;
const utils_1 = require("@obvio/utils");
const path_to_regexp_1 = require("path-to-regexp");
const href_1 = require("../href");
function matchRoute(route, pattern) {
    return new RegExp(`^${pattern
        .replaceAll(/\[{1,2}\.{3}[\w-]+?\]{1,2}/gu, '.+')
        .replaceAll(/\[{1,2}[\w-]+?\]{1,2}/gu, '[^/]+')}/?$`, 'u').test(new href_1.Href(route).pathname);
}
exports.matchRoute = matchRoute;
function resolveRewrite(route, { beforeFiles, afterFiles, fallback }, pages) {
    const rewrites = [...beforeFiles, ...afterFiles, ...fallback];
    const { pathname } = new href_1.Href(route);
    const rewrite = rewrites.find(({ source, destination }) => destination && (0, path_to_regexp_1.pathToRegexp)(source).test(pathname));
    if (rewrite === null || rewrite === void 0 ? void 0 : rewrite.destination) {
        const keys = [];
        const match = (0, path_to_regexp_1.pathToRegexp)(rewrite.source, keys).exec(pathname);
        if (match) {
            let { destination } = rewrite;
            keys.forEach(({ name }, i) => {
                const keyRegex = new RegExp(`:${name}\\b`, 'u');
                destination = destination.replace(keyRegex, match[i + 1]);
            });
            const nextRoute = pages.find((page) => matchRoute(destination, page));
            if (nextRoute) {
                return {
                    href: nextRoute,
                    pathParams: getPathParams(destination, nextRoute),
                };
            }
        }
    }
}
exports.resolveRewrite = resolveRewrite;
function getPathParams(href, nextRoute) {
    const hrefParts = href.split('/');
    const params = nextRoute.split('/');
    return Object.fromEntries(params
        .map((param) => {
        if (/^\[{1,2}\.{3}/u.test(param)) {
            return [
                param.replace(/^\[{1,2}\.{3}(.+?)\]{1,2}$/u, '$1'),
                hrefParts.splice(0, Infinity),
            ];
        }
        const part = hrefParts.shift();
        return param.startsWith('[')
            ? [param.replace(/^\[+(.+?)\]+$/u, '$1'), part]
            : [];
    })
        .filter((entry) => entry.length > 0));
}
exports.getPathParams = getPathParams;
function localizeRoute(route, routes = {}) {
    var _a;
    const href = new href_1.Href(route);
    if (href.pathname === '/') {
        return route;
    }
    const routeParts = href.pathname.replaceAll(/^\/|\/$/gu, '').split('/');
    let localizedPart;
    for (let i = 0; i < routeParts.length; i += 1) {
        const part = `/${routeParts.slice(0, i + 1).join('/')}`;
        const replacement = (_a = Object.entries(routes).find(([pattern]) => matchRoute(part, pattern))) === null || _a === void 0 ? void 0 : _a[1];
        if (replacement) {
            localizedPart = { part, replacement };
        }
    }
    if (localizedPart) {
        href.pathname = fillPathParams(href.pathname.replace(localizedPart.part, localizedPart.replacement), href.pathname);
    }
    return href.toString();
}
exports.localizeRoute = localizeRoute;
function fillPathParams(route, path) {
    const routeParts = (0, utils_1.exclude)(route.split('/'), '');
    const pathParts = (0, utils_1.exclude)(path.split('/'), '');
    return `/${(0, utils_1.exclude)(routeParts.map((part) => {
        const pathPart = pathParts
            .splice(0, /^\[{1,2}\.{3}/u.test(part) ? Infinity : 1)
            .join('/');
        return part.startsWith('[') ? pathPart : part;
    }), '').join('/')}`;
}
